import type { Plugin } from 'vue';
import type { Router } from 'vue-router';
import { useEventBus } from '@/app/core/event-bus';
import { useRecentlyVisitedStore } from './stores';

interface Options {
  router: Router;
}

export function createRecentlyVisited(options: Options): Plugin {
  return {
    install() {
      const { router } = options;
      const eventBus = useEventBus();
      const store = useRecentlyVisitedStore();

      router.afterEach((to, from) => {
        if (to.meta.trackVisit && to.path !== from.path) {
          store.add(to);
        }
      });

      eventBus.on('appInitialized', async () => {
        await store.fetch();
        // Remove invalid records
        store.records = store.records.filter(({ path }) => !!router.resolve(path));
      });
    },
  };
}

export * from './stores';
export * from './components';
